import * as yup from 'yup';

export interface EsiFeeScheduleFormValues {
  program: string;
  paymentType: string;
  price: number | null;
  upc: string;
  description: string;
}

export const DEFAULT_ESI_FEE_SCHEDULE_FORM_VALUES: EsiFeeScheduleFormValues = {
  program: '',
  paymentType: '',
  price: null,
  upc: '',
  description: '',
};

const required = (field: string): string => `${field} is required`;
const invalidNumber = (field: string): string =>
  `${field} must be a valid number`;

export const esiFeeScheduleFormSchema = yup.object({
  program: yup.string().defined(),
  paymentType: yup.string().trim().required(required('Payment type')),
  price: yup
    .number()
    .nullable()
    .typeError(invalidNumber('Price'))
    .required(required('Price'))
    .min(0, invalidNumber('Price'))
    .test(
      'is-finite',
      invalidNumber('Price'),
      value => value == null || isFinite(value),
    ),
  upc: yup.string().trim().required(required('UPC')),
  description: yup.string().defined(),
}) as yup.ObjectSchema<EsiFeeScheduleFormValues>;
